import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/coon-rapids-mn")({
  beforeLoad: () => {
    throw redirect({
      to: "/service-areas/$slug",
      params: { slug: "coon-rapids" },
      statusCode: 301,
    });
  },
});
